<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="C" itemcode="C-CYLZSXS"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
						<div class="map_title_tab right_boxtitle ">
							<span class="fl title" @click="pageTypeToggle(1)" :class="pageType == 1?'current':''">{{curWebsite.type != 5 ? '产业链招商':'智能推荐'}}</span>
							<span class="fl title" @click="pageTypeToggle(2)" :class="pageType == 2?'current':''">企业分布</span>
							<!-- v-if="citymapdata.length>0" -->
							<div class="fr search-box nz-search-box">
								<span class="searchtype">全部内资企业库</span>
								<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"
									@keydown="searchenter" />
								<button class="search-btn" @click="searchkwfun">查询</button>
							</div> 
						</div> 
						
					<div class="opport-screen-list1" v-show="pageType == 1"> 
					<!-- <ClueNav tabCode="cytztj"></ClueNav> -->
						<dl class="opport-screen bdbe">
							<dt class="fl">企业实力</dt>
							<dd class="fl ">
								<!--  	:style=" index<7?'font-weight:bold':''" -->
								<span @click="comSearchdata[0]=0; ajaxsearchcompany()"
									:class="comSearchdata[0] == 0 ?'a-screen current' : 'a-screen'">全部</span>
								<span :key="item.tagCode" v-for="(item,index) in totalqysl"
									@click="comSearchdata[0]=item.tagCode; ajaxsearchcompany()" 
									:class="{'a-screen':true,'current':comSearchdata[0] == item.tagCode,'fwb':item.fwb}">{{item.tagName}}</span>
							</dd>
						</dl>
						<!-- 省市区筛选 -->
						<cityScreen @getEnterpriseList="cityScreenFun"></cityScreen>
						<!-- <dl class="opport-screen bdbe">
							<dt class="fl">省份地区</dt>
							<dd class="fl">
								<span :class="provinceid == 0?'current a-screen':'a-screen'"
									@click="provincechoose(0,'all');userdata.provinceText='全国地区' ">全国地区</span>
								<span :key="index" v-for="(item,index) in provincedata"
									@click="provincechoose(item.areaId,index);userdata.provinceText=item.areaName"
									:class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="citydata.length!=0">
							<dt class="fl">城市地区</dt>
							<dd class="fl">
								<span :class="cityid == 0?'current a-screen':'a-screen'"
									@click="choosecity(0,'all');userdata.cityText=''">全部</span>
								<span :key="index" v-for="(item,index) in citydata"
									@click="choosecity(item.areaId,index);cityid=item.areaId;userdata.cityText=item.name"
									:data="item.areaId"
									:class=" item.areaId == cityid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="countydata.length!=0">
							<dt class="fl">区县地区</dt>
							<dd class="fl">
								<span :class="countyid == 0?'current a-screen':'a-screen'"
									@click="choosecounty(0);userdata.countyText=''">全部</span>
								<span :key="index" v-for="(item,index) in countydata"
									@click="choosecounty(item.areaId);countyid=item.areaId;userdata.countyText=item.name"
									:data="item.areaId"
									:class=" item.areaId == countyid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
							</dd>
						</dl> -->
						<dl class="opport-screen bdbe">
							<dt class="fl">产业分类</dt>
							<dd class="fl screenop">
								<span @click="chooseNotion(1,'a',{lable:'全部',value:0,children:[]});notionstep=0"
									:class="notionCode == 0 ?'a-screen current':'a-screen'">全部</span>
								<span :key="index" v-for="(item,index) in notionlist"
									:class="chooseNotionlist[0] == item.value ?'a-screen current':'a-screen'"
									@click="chooseNotion(1,'a',item)">{{item.label}}</span>
								<span class="chanyeshezhi" @click="routerlinkid('/userFocus',1)">产业设置</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist1.length>0">
							<dt class="fl titleop">一级产业</dt>
							<dd class="fl">
								<span @click="chooseNotion(2,'all',fenkd)"
									:class="chooseNotionlist[1]==0 ?'a-screen current':'a-screen'">全部</span>
								<span :key="index" v-for="(item,index) in notionlist1"
									:class="chooseNotionlist[1] == item.value ?'a-screen current':'a-screen'"
									@click="chooseNotion(2,'a',item)">{{item.label}}
									<!-- <em class="num">({{item.count}})</em> -->
								</span>
								<!-- <el-tooltip class="item smartTip-text" effect="light" placement="top-start"><i
										class="el-icon-question listeltootipicon"></i>
									<div slot="content" class="list_tips">
										<p>括号内的数字为所选城市对应的全部内资企业数量，并按数量对产业进行了排序</p>
									</div>
								</el-tooltip> -->
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist2.length>0">
							<dt class="fl titleop">二级细分</dt>
							<dd class="fl">
								<span @click="chooseNotion(3,'all',fenkd)"
									:class="chooseNotionlist[2]==0 ?'a-screen current':'a-screen'">全部</span>
								<span :key="index" v-for="(item,index) in notionlist2"
									:class="chooseNotionlist[2] == item.value ?'a-screen current':'a-screen'"
									@click="chooseNotion(3,'a',item)">{{item.label}}
									<!-- <em class="num">({{item.count}})</em> -->
								</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="notionlist3.length>0">
							<dt class="fl titleop">三级细分</dt>
							<dd class="fl">
								<span @click="chooseNotion(4,'all',fenkd)"
									:class="chooseNotionlist[3]==0?'a-screen current':'a-screen'">全部</span>
								<span :key="index" v-for="(item,index) in notionlist3"
									:class="chooseNotionlist[3] == item.value ?'a-screen current':'a-screen'"
									@click="chooseNotion(4,'a',item)">{{item.label}}<!-- <em class="num">({{item.count}})</em> --></span>
							</dd>
						</dl>
					</div>
					<!-- 企业分布地图和饼图 -->
					<div class="notion-map" v-show="pageType == 2">
						<div class="recommd-map">
							<div class="citymapblock por">
								<chainMap :mapdata="citymapdata" v-if="citymapdata.length>0" :citymapflag="true" v-on:chartmapclick="chartmapclick" :choosecity='choosecity'></chainMap>
								<div class="conallEnterprise_pie" id="conallEnterprise_pie" ></div>
							</div>
						</div>
					</div>
				</div>

				<div class="whitebox" style="min-height: 160px;" >
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span
								class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'"
							@click="enlistExport()" v-if="userdata.groupType == 1"
							v-show="exportnum>0 && enterpristlist.length>0">
							<span>导出数据</span>
						</div>
					</div>
					<!-- 多维度分数筛选 全部内资企业删除排序功能-->
					<ul class="dimensionScreen oh w95mg" v-show="enterpristlist.length>0">
						<li :class="orderField == list.type ?'fl current ':'fl '" :key="index"
							v-for="(list,index) in dimensionList" @click="tablesort(list.type);"
							v-show="list.name!='融资时间'||searchtype == 2">
							<span :class="orderField == list.type ?'sortname current ':'sortname '">{{list.name}}</span>
							<span :class="ordertype == 1?'timesorticon up':'timesorticon down'"></span>
						</li>
					</ul>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>编辑</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td>{{(page-1)*pageSize+i+1}}</td>
								<td class="title" @click="routerlinkid('/enterprises',list.stockCode,curindex)">
									{{list.title}}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" :key="index" v-for="(item,index) in list.notionlist"
										@click="tagrouter('/enterpriseTag',0,'notion',item.id,item.name)">{{item.name}}</span>
								</td>
								<td class="conpanytags notiontags">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.area}}</td>
								<td>{{list.zs100000}}</td>
								<td class="collectfont1"><span
										@click="listToggleCollect(list)">{{list.collectId == 0?'加入':'移除'}}<br />目标企业</span>
								</td>
							</tr>
						</table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
				
			</div>
			<!-- 导出列表弹框 -->
			<div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b
							class="redfont">{{exportnum}}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
					<span class="closebtn" @click="exportpop=false"></span>
				</div>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script>
	import {
		dataInJs
	} from "../../utils/city.js";
	import {totalqysl} from '@/utils/enterprise-tag.js'
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite:this.$api.getWebsiteType(),
				title: "全部内资企业",
				searchPlaceholder: '请输入企业名称',
				fenkd: {
					children: []
				},
				curindex: 6,
				comajaxurl: "",
				enterinarr: [{
						curindex: 1,
						type: 9,
						name: "上市公司",
						tagnum: 10010,
					},
					{
						curindex: 2,
						type: 1,
						name: "龙头企业",
						tagnum: 10010,
					},
					{
						curindex: 3,
						type: 2,
						name: "创新企业",
						tagnum: 3,
					},
					{
						curindex: 4,
						type: 3,
						name: "优质企业",
						tagnum: 10009
					},
				],
				tz_enterinarr: [{
						pagecode: 'A-CXQY',
						type: 2,
						name: "创新企业",
						tagnum: 3,
						hxtagname: '&拿地信息&股权投资信息&财力稳健&项目投资信息&融资时间标签&融资金额标签&'
					},
					{
						pagecode: 'A-YZQY',
						type: 3,
						name: "优质企业",
						tagnum: 10009,
						hxtagname: '&拿地信息&股权投资信息&'
					},
				],
				userdata: {},
				notionCode: 0,
				chooseNotionlist: [0, 0, 0, 0, 0],
				searchtype: 0,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "",
				zcnotionlist1: [],
				zcnotionlist2: [],
				notionlist: [],
				notionlist1: [],
				notionlist2: [],
				notionlist3: [],
				notionlist4: [],
				notionlist5: [],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				provinceid: 0,
				cityid: 0,
				countyid: 0,
				provincedata: dataInJs(),
				citydata: [],
				countydata: [],
				initialTagdata: [{
					tagName: "",
					tagCode: "",
					children: []
				}],
				comSearchdata: [0, 'empty', 'empty', 'empty'], //公共科技实力下拉框版 存储值 
				totalqysl:[],
				totalqysl_shangshi: [],
				totalqysl_youzhi: [],
				searchtagdata: ['0'],
				calcity:0,
				enterpristlist: [], 
				num: 0,
				orderField: 0, //排序字段 0 分数 1 时间
				ordertype: 0, //排序方式 0 降序 1 升序   
				commontagcode: 0,
				tyinitialTagdata: [],
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',
				notionstep: 0,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}, {
					name: '控制企业',
					type: 10
				}, ],
				usertaglist:[],//默认用户tag
				initialUserNotionlist:[],//存后台为用户设置的概念列表
				pageType:1,//页面类型 1=智能推荐 2=企业分布
				citymapdata:[],//城市地图数据
				ajaxurl1:"",
				ajaxurl2:"",
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			var _this = this;
			this.userdata = this.getuseriformation();
			this.totalqysl=totalqysl(); 
			// _this.notionlist=NotionTree; 
			//用户概念数据
			this.$axios.get(this.$api.cyl.notion.list()+'?level=4',{headers:{AuthToken:this.userdata.token}}).then(function(res){ 
				console.log('用户概念数据5',res.data.list)
				if(res.data.success){    
					var ddds=[];  
					_this.notionlist=res.data.list == null ? []:res.data.list;  
						// console.log('父组件初始用户概念数据',_this.notionlist);
				}else{ 
					
				} 
			}).catch(function(error) {
				// 请求失败处理 console.log(error);
			});
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			this.initialUserNotionlist = this.taglistfun(this.userdata.notionText,this.userdata.notion);
			this.usertaglist=this.taglistfun(this.userdata.tagText,this.userdata.tag);
			this.ajaxsearchcompany(1);
		},
		methods: {
			//省份城市选择
			cityScreenFun(pid,cid,cuid){ 
				this.ttsg();
				this.cityid = cid;
				this.countyid = cuid; 
				this.provinceid = pid;
				this.ajaxsearchcompany();
			}, 
			//页面切换执行
			pageTypeToggle(type){
				this.pageType = type;
				this.calcity=type-1;
				if(type == 2){
					this.ajaxsearchcompany(1);
				} 
			},
			chartmapclick:function(data){ 
				// console.log('地图数据',data); 
				var type="";
				if(data.data!=undefined && data.data.length>0){ 
					type=1;
				};
				// this.choosecityid(data.id,type);20240109暂停省份点击展示细节图
			}, 
			// choosecityid(id,type){
			// 	if(type == 1){
			// 		this.provinceid=id;
			// 		this.cityid=0;
			// 	}else{
			// 		this.provinceid=0;
			// 		this.cityid=id;
			// 	} 
			// 	this.ajaxsearchcompany();
			// }, 
			jsondouhao(name,data){
				if(data.length>0){ 
					var notionja="";
					if(data.length!=0){
						var douhao='%2C';
						for(var i=0;i<data.length;i++){ 
							if(i==data.length-1){
								douhao='';
							}
							notionja+=data[i].id+douhao;
						}
						notionja='&'+name+'='+notionja;
						return notionja;
					} 
				}else{
					return "";
				}
			},
			//企业列表导出数据
			getajaxUrl(apiurl, searchtype) {
				if (searchtype != 'search') {
					this.searchtext = "";
				}
				var _this = this,
					ajaxurl = '';
				//公司列表 type:1/2 area:provinceid industry行业id capital 注册资本 （暂无） 标签（暂无） chain相关产业链（暂无） page页码
				var searchtagdata1 = this.searchtagdata.filter(item => {
					return item != 'empty' && item != 0;
				});
				this.comSearchdata.forEach(item => {
					if (item != 'empty' && item != 0) {
						searchtagdata1.push(item);
					}
				})
				console.log('searchtagdata1',searchtagdata1) 
				var tagaja = '';
				if (searchtagdata1.length > 0) {
					tagaja = _this.datajoin('tag', searchtagdata1);
				}
				// console.log('-----',this.userNotionlist);
				var notionja = this.jsondouhao('notion', this.userNotionlist);
				var kwaja = this.splicing('kw', this.searchtext);
				var countyidja = this.splicing('county', this.countyid);
				var provinceidja = this.splicing('province', this.provinceid);
				var cityidja = this.splicing('city', this.cityid);
				ajaxurl = apiurl + '?type=' + this.searchtype + '&search=1' + tagaja + "&orderField=" + this
					.orderField + "&orderType=" + this.ordertype + notionja + kwaja + countyidja + provinceidja + cityidja;
				return ajaxurl
			},
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				}
				// console.log(this.userdata.groupType,this.exportnum,this.allowexport,this.total);  
				// var ajaxurl=this.$api.cyl.enterprise.export()+'?token='+this.token+'&type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+';
			},
			exportlistFun() { //下载报告
				var _this = this;
				var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export(), 'search') + '&token=' + this.userdata
					.token;
				this.confirmtext = "导出中";
				var iframe = document.getElementById("exportIframe");
				iframe.setAttribute("src", ajaxurl);
				_this.exportnum = this.exportnum--;
				setTimeout(() => {
					_this.confirmtext = "导出成功";
					_this.exportpop = false;
					_this.exportbtn = false;
				}, 5000)
				setTimeout(() => {
					_this.exportbtn = true;
					_this.confirmtext = "确认导出";
					console.log('一分钟冷却计时')
				}, 60000)
			},
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.ordertype = Math.abs(this.ordertype - 1);
				} else {
					this.orderField = field;
				}
				console.log('排序',this.orderField,this.ordertype)
				this.ajaxsearchcompany();
			},
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				if (this.searchtext.length > 0) {
					var pathque = {
						kw: this.searchtext
					};
					let routeUrl = this.$router.resolve({
						path: '/totalSearch',
						query: pathque
					});
					window.open(routeUrl.href, '_blank');
				} else {
					this.$message({
						type: 'error',
						message: '请输入关键词搜索',
					});
				}
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			}, 
			//选择标签
			choosetaglist1(obj, index) {
				// console.log(obj.target.value, this.initialTagdata.length, index + 1);
				// if(	this.searchtagdata[index + 1] == values){
				// 	this.searchtagdata[index + 1]='empty';
				// }else{
				// 	this.searchtagdata[index + 1] = values;
				// } 
				this.comSearchdata[index + 1] = obj.target.value;
				console.log(this.comSearchdata);
				this.ajaxsearchcompany();
			},
			pageHandler: function(page) {
				this.ajaxsearchcompany(page, 'srot', 'search');
			}, 
			ttsg() {
				this.notionlist1 = [];
				this.notionlist2 = [];
				this.notionlist3 = [];
				this.notionlist4 = [];
				this.notionlist5 = [];
				this.notionCode = 0;
				this.chooseNotionlist = [0, 0, 0, 0, 0, 0];
			},
			choosecity(id, i) {
				//	console.log('choosecity',id);
				if (this.cityid != id) {
					this.clearnotion();
					this.cityid = id;
					this.countyid = 0;
					if (i != "all" && this.citydata[i].children != null) {
						this.countydata = this.citydata[i].children;
					} else {
						this.countydata = [];
					}
					this.page = 1;
					this.ajaxsearchcompany(1, 'sort');
				}
			},
			
			//概念单选 层级显示
			chooseNotion(step, type, data) {
				// console.log('概念单选',step,type,data)
				if (type == 'all') {
					this.notionCode = this.chooseNotionlist[step - 2];
					this.chooseNotionlist[step - 1] = '0';
				} else {
					this.chooseNotionlist[step - 1] = data.value;
					for (var i = 0; i < this.chooseNotionlist.length; i++) {
						if (i > step - 1) {
							this.chooseNotionlist[i] = '0';
						}
					}
					this.notionCode = data.value;
					// this.userNotionlist = data;
				}
				if (data.children == null) {
					data.children = [];
				}
				if (step == 1) {
					if (type == 'a') {
						this.notionlist1 = [];
					}
					this.zcnotionlist1 = data.children.filter(list => {
						return list.label != '环保';
					});
					this.notionlist1  = this.zcnotionlist1;
					// console.log(this.zcnotionlist1)
					this.notionlist2 = [];
					this.notionlist3 = [];
					this.notionlist4 = [];
				} else if (step == 2) {
					this.zcnotionlist2 = data.children;
					this.notionlist2 = data.children;
					this.notionlist3 = [];
					this.notionlist4 = [];
				} else if (step == 3) {
					this.notionlist3 = data.children;
					this.notionlist4 = [];
				} else if (step == 4) {
					this.notionlist4 = data.children;
					this.notionlist5 = [];
				} else if (step == 5) {
					this.notionlist5 = data.children;
				} 
				// console.log(this.notionCode);
				this.notionstep = step;
				this.ajaxsearchcompany(1);

				// if(step != 1){ //search =0的时候大分类没数据所以不请求后台
				// this.ajaxsearchcompany(1);
				// // 	if (step < 3) {
				// // 	this.ajaxsearchcompany(1);
				// // } else {
				// // 	this.ajaxsearchcompany();
				// // }
				// }
			},
			ajaxsearchcompany(pages) { 
				this.bus.$emit('loading', true);
				this.page = pages ? pages : 1;
				var _this = this;
				var notionstepd = this.notionstep;
				// var tagaja=_this.jsondouhao('tag',this.usertaglist);
				var tagaja = '';
				var searchtagdata1 = this.searchtagdata.filter(item => {
					return item != 'empty' && item != 0;
				});
				this.comSearchdata.forEach(item => {
					if (item != 'empty' && item != 0) {
						searchtagdata1.push(item);
					}
				})
				if (searchtagdata1.length > 0) {
					tagaja = _this.datajoin('tag', searchtagdata1);
				}else{
					tagaja=_this.jsondouhao('tag',this.usertaglist);
				}
				 console.log(this.notionCode);
				if(this.notionCode== 0){ //默认筛选后台为用户设置的概念 this.userdata.notion
					var notionja = this.splicing('notion', this.userdata.notion);
				}else{
					var notionja = this.splicing('notion', this.notionCode);
				}
				var calcitynoj=this.calcity == 0 ? '&calCity=0' : '&calCity=2';
				
				// this.ajaxurl1=calcitynoj+this.splicing('city',this.cityid)+this.splicing('province',this.provinceid)+this.splicing('kw',this.searchtext)+notionja+tagaja+"&orderField=" + this.orderField + "&orderType=" + this.ordertype+'&page='+this.page;
				// calCity=1&
				var ajaxurl=this.$api.cyl.enterprise.list()+'?type=0&search=1'+calcitynoj+this.splicing('city',this.cityid)+this.splicing('province',this.provinceid)+this.splicing('kw',this.searchtext)+notionja+tagaja+"&orderField=" + this.orderField + "&orderType=" + this.ordertype+'&page='+this.page;
				console.log(ajaxurl,_this.calcity)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('企业列表'+_this.calcity, res.data);
					if (res.data.success) { 
						if(_this.calcity != 0){
							//只要地图分布数据 企业分布地图数据 
							var citylistd=[],citytest=res.data.cityList;
										for(var i=0;i<citytest.length;i++){
											let citylista ={}; 
											citylista.value=citytest[i].count;  
											citylista.id=citytest[i].id;  
											citylista.name=_this.citynameremove(citytest[i].name); 
											citylista.data=[];
											for(var p=0;p<citytest[i].children.length;p++){
												let citydtac={};
												citydtac.value=citytest[i].children[p].count;
												citydtac.id=citytest[i].children[p].id;
												citydtac.name=citytest[i].children[p].name;
												citylista.data.push(citydtac); 
											}
											citylistd.push(citylista); 
										}; 
										// if(_this.notioneditbtn){
											_this.selectcitydata=citytest;
											_this.citymapdata=citylistd;
											_this.zsdt_pie(citylistd);
											_this.cityflag=true;
											_this.total1=res.data.totalRecord; 
										// } 
						}else{
							var dataenterlist = res.data.list;
							_this.exportnum = res.data.extend.exportRemainder;
							_this.allowexport = res.data.extend.allowExport; 
							for (var i = 0; i < res.data.list.length; i++) {
								dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[
									i].notionCode, 'notionsort');
								dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i]
									.tagCode);
							}
							_this.totalPage = res.data.totalPage;
							_this.pageSize = res.data.pageSize;
							_this.total = res.data.totalRecord;
							_this.haspage = res.data.list.length == res.data.pageSize;
							_this.kwtextsearch = _this.searchtext != "";
							_this.kwtextsearchtext = _this.searchtext;
							_this.exportbtn = true;
							_this.confirmtext = "确认导出";
							_this.enterpristlist = dataenterlist;
						} 
						_this.bus.$emit('loading', false);
					} else {

					}
				}).catch(function(error) {});
				// console.log(datas);  
			},
			// //省份城市选择
			// provincechoose(id, i) {
			// 	if (this.provinceid != id) {
			// 		this.ttsg();
			// 		this.cityid = 0;
			// 		this.countyid = 0;
			// 		this.page = 1;
			// 		this.provinceid = id;
			// 		this.countydata = [];
			// 		if (i != "all" && this.provincedata[i].children != null) {
			// 			this.citydata = this.provincedata[i].children;
			// 		} else {
			// 			this.citydata = [];
			// 		}
			// 		this.ajaxsearchcompany(1, 'sort');
			// 	}
			// },
			// choosecounty(id) {
			// 	//	console.log('choosecity',id);
			// 	this.countyid = id;
			// 	this.page = 1;
			// 	this.ajaxsearchcompany();
			// },
			//招商地图的饼图 
			zsdt_pie(data){ 
				// console.log('招商地图的饼图',data) ;
				// return;
					var chart = echarts.init(document.getElementById('conallEnterprise_pie'));
					var sdata=[],allnum=0;
					if(data.length>10){
						for(var i=0;i<data.length;i++){
							if(i>9){
								allnum=allnum+data[i].value;
							}else{
								sdata.push(data[i]);
							}
						}
						sdata.push({name:'其他',value:allnum})
					}else{
						sdata=data;
					}
					var option = {
					tooltip: {
							trigger: 'item',
							formatter: '{a} <br/>{b}: {c} ({d}%)'
					}, 
					series: [ 
					{
							name: '省份',
							type: 'pie',
							radius: ['0%', '60%'],
							labelLine: {
									length: 30
							},
								label: {show: true,position: 'outside',color:'#000',fontSize:12,formatter: '{b},{d}'+'%',},
							data:sdata,
					}
				]
			};
			chart.setOption(option);
			},
			//  
		}
	}
</script>

<style>


</style>